<section [ngClass]="complexClasses" class="cards-component rounded-lg p-4 h-[400px] flex flex-col duration-200 relative">
	<div class="flex items-start justify-between mb-3">
		<!-- Title left -->
		<div class="flex items-center gap-3">
			<h2 class="text-lg font-medium text-[#141437] dark:text-white">{{cardHeading}}</h2>
		</div>

		<!-- Segmented control (Graph / Table) right -->
        @if (showToggle) {
        <div class="flex items-center gap-2">
            <!-- Use the project's segmented toggle component. Pass headerOptions and listen for viewChanged -->
            <app-toggle-btns
                [headerOptions]="{ showlabels: showLabels, showIcon: true, showToggleButton: true, toggleOptions: toggleOptions, showTable: view === 'table' }"
                (viewChanged)="onToggle($event)" class="px-3 py-1 text-sm">
            </app-toggle-btns>
        </div>
        }
	</div>

	<!-- Summary badges above chart -->
	<div class="flex items-center gap-4 mb-4">
		<div class="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
			<span class="w-2 h-2 rounded-full bg-[#AD46FF] inline-block"></span>
			<span>Current: <span class="font-semibold text-slate-800 dark:text-slate-100">{{ formatValue(data?.summary?.current ?? data?.current) }}</span></span>
		</div>

		@if (hasPreviousData) {
			<div class="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
				<span class="w-2 h-2 rounded-full bg-slate-300 dark:bg-slate-600 inline-block"></span>
				<span>Previous: <span class="font-semibold text-slate-800 dark:text-slate-100">{{ formatValue(data?.summary?.previous ?? data?.previous) }}</span></span>
			</div>
		}

		@if (hasAllTimeData) {
			<div class="ml-auto">
				<span class="bg-slate-100 dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs py-1 px-3 rounded-md transition-colors duration-200">{{ data.allTimeHeading }}: {{ formatValue(data?.summary?.allTime ?? data?.allTime) }}</span>
			</div>
		}
	</div>

	<!-- Views -->
    <div class="cards-views flex-1 min-h-0 overflow-hidden rounded-md">
        @if (view === 'chart') {
            <div class="h-full">
                <app-line-chart
                    [data1]="data?.chartData || data"
                    [data2]="data?.previousChartData || []"
                    [valueKey]="valueKey"
                    [unit]="unit"
                    [showYAxis]="false"
                    [showYAxisGrid]="false"
                    [showYAxisPath]="true"
                    [curveType]="curveType"
                    [valueFormat]="valueFormat"
                    >
                </app-line-chart>
            </div>
        }

        @if (view === 'table') {
            <div class="h-full overflow-hidden">
                <app-scroll-table
                    [tableData]="data?.tableData || data"
                    [previousData]="data?.previousTableData || []"
                    [headers]="tableHeaders"
                    [showHeading]="false">
                </app-scroll-table>
            </div>
        }
    </div>
    @if(isLoading){
        <app-individual-toaster></app-individual-toaster>
      }
</section>